import { Gender } from 'models/options';

export const GENDER_OPTIONS = {
  en: [
    {
      id: Gender.MALE,
      name: 'Male',
    },
    {
      id: Gender.FEMALE,
      name: 'Female',
    },
  ],
  es: [
    {
      id: Gender.MALE,
      name: 'Masculino',
    },
    {
      id: Gender.FEMALE,
      name: 'Mujer',
    },
  ],
};

export const YES_NO_OPTIONS = {
  en: [
    {
      id: true,
      name: 'Yes',
    },
    {
      id: false,
      name: 'No',
    },
  ],
  es: [
    {
      id: true,
      name: 'Sí',
    },
    {
      id: false,
      name: 'No',
    },
  ],
};

export const SUPERVISOR_OPTIONS = {
  en: [
    {
      id: true,
      name: 'Supervisor',
    },
    {
      id: false,
      name: 'Non Supervisor',
    },
  ],
  es: [
    {
      id: true,
      name: 'Supervisor',
    },
    {
      id: false,
      name: 'No supervisor',
    },
  ],
};

export const SKILLED_NON_SKILLED_OPTIONS = {
  en: [
    {
      id: true,
      name: 'Skilled',
    },
    {
      id: false,
      name: 'Non Skilled',
    },
  ],
  es: [
    {
      id: true,
      name: 'Experto',
    },
    {
      id: false,
      name: 'No calificado',
    },
  ],
};

export const PAYMENT_TYPE = {
  en: [
    {
      id: 'Hourly',
      name: 'Hourly',
    },
    {
      id: 'Salary',
      name: 'Salary',
    },
  ],
  es: [
    {
      id: 'Hourly',
      name: 'Cada hora',
    },
    {
      id: 'Salary',
      name: 'Sueldo',
    },
  ],
};

export const YEARS_OF_EXPERIENCE = [
  { id: 1, name: '0-1' },
  { id: 2, name: '2-7' },
  { id: 8, name: '8-13' },
  { id: 14, name: '14-19' },
  { id: 20, name: '20+' },
];
